import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStore} from "hooks/useStore";
import {ANNOUNCEMENT_POPUP_IMAGE_URL} from "./announcementConstants";
import {hasSeenAnnouncement, markAnnouncementSeen} from "./announcementStorage";
import {PopupImage, StyledModal} from "./CustomerAnnouncementPopup.styles";

export const CustomerAnnouncementPopup = observer(() => {
    const stores = useStore();
    const userId = stores?.meStore?.userId;
    const isCandidateCustomer = stores?.meStore?.checkRole("isCandidateCustomer");
    const isVisible = stores?.appStore?.isAnnouncementPopupVisible;

    useEffect(() => {
        if (!userId || isCandidateCustomer) {
            return;
        }
        if (!hasSeenAnnouncement(userId)) {
            stores.appStore.setAnnouncementPopupVisible(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, isCandidateCustomer]);

    const handleClose = () => {
        markAnnouncementSeen(userId);
        stores.appStore.setAnnouncementPopupVisible(false);
    };

    return (
        <StyledModal
            visible={Boolean(isVisible)}
            onCancel={handleClose}
            footer={null}
            centered
            destroyOnClose
            width={960}
            bodyStyle={{padding: 0}}
        >
            <PopupImage src={ANNOUNCEMENT_POPUP_IMAGE_URL} alt="Vigo 7. Yıl Duyurusu" />
        </StyledModal>
    );
});
